import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles/Browse.module.css";
import ScenarioCard from "../mainlayout/body/ScenarioCard";
import * as ScenarioAPI from '../../services/ScenarioServices';
import Loading from "../loading/Loading";
import LeftSidebar from "../mainlayout/body/LeftSideBar";

const Browse = () => {
    const { tag } = useParams();
    const [scenarios, setScenarios] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [activeTab, setActiveTab] = useState("");
    // const [activeTab, setActiveTab] = useState("Featured");
    const [activeSubTab, setActiveSubTab] = useState("");

    useEffect(() => {
        setIsLoading(true);
        const fetchScenarios = async () => {
            try {
                const data = await ScenarioAPI.searchByTag(tag);
                setScenarios(data);
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                console.error(`Error: ${error}`);
            }
        };
        fetchScenarios();
    }, [tag]);

    if (isLoading) {
        return <div className={styles.centeredContainer}><Loading/></div>;
    }

    return (
        <div key={tag} className={styles.container}>
            {/* Left */}
            <LeftSidebar
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                activeSubTab={activeSubTab}
                setActiveSubTab={setActiveSubTab}
            />
            {/* Right */}
            <main className={styles.rightSection}>
                {/* Heading */}
                <div className={styles.heading}>
                    <h1 className={styles.browsePageTitle}>
                    Scenarios tagged with{" "}
                    <span className={styles.tagTerm}>{tag}</span>
                    </h1>
                </div>

                {/* Results */}
                {scenarios && scenarios.length > 0 ? (
                    <div className={styles.resultsGrid}>
                        {scenarios.map((scenario) => (
                            <ScenarioCard key={scenario._id} scenario={scenario} />
                        ))}
                    </div>
                ) : (
                    <div className={styles.noResultsContainer}>
                        <p className={styles.noResultsMessage}>
                            No scenarios found for the tag "<span className={styles.tagTerm}>{tag}</span>".
                        </p>
                    <p className={styles.noResultsSuggestion}>
                        Try exploring other tags or searching directly.
                    </p>
                </div>
            )}
        </main>
    </div>
    );
};

export default Browse;
